import { useEffect } from "react";
import { useNaverLogin } from "views/naver/hooks/useNaverLogin";

export const NaverLogout = (rootStore: any) => {
  const { naverLogin } = useNaverLogin(rootStore);

  useEffect(() => {
    naverLogin({
      clientId: process.env.REACT_APP_NAVER_CLIENT_ID!,
      redirectUri: process.env.REACT_APP_NAVER_REDIRECT_URI!,
    });
  }, []);

  return <div></div>;
};
